import { defineComponent as _defineComponent } from 'vue'
import useUser from '@/mixins/useUser';
import { PropType, toRefs } from 'vue';
import { User } from '@/models/User';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendedMessage',
  props: {
  user: {
    type: Object as PropType<User>,
    default: null
  },
},
  setup(__props) {

const props = __props;



const { user } = toRefs(props);

const { tUserFallback: t } = useUser(user);


return { __sfc: true,props, user, t }
}

})